import { APICallMethod } from './const';

const VALID_URL_REGEXP = new RegExp(/(\/\/.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}/g);

export class API {
  static isURLValid = (url) => url.match(VALID_URL_REGEXP);

  static stringifyURLParams = (params) => new URLSearchParams(params).toString();

  static call = (url, params = {}, options = { credentials: 'include' }, method = APICallMethod.FETCH) => {
    const resourceParams = API.stringifyURLParams(params);
    const resource = url + (resourceParams ? '?' + resourceParams : '');

    if (!API.isURLValid(resource)) {
      return console.warn('invalid url: ', resource);
    }

    if (method === APICallMethod.FETCH) return fetch(resource, options).catch(error => error); // TODO: add error handler 
    else if (method === APICallMethod.IMAGE) return (new Image).src = resource;
  }
}
